import { translate } from '@cashfree-intl/coherent'; /* eslint-disable */
import * as Yup from 'yup';

const vendorDetailsFormvalidationSchema = (
  step,
  incrementalVendorOnboarding = false,
) =>
  Yup.object({
    email:
      step === 1
        ? Yup.string()
            .email(`${translate('enter_valid_email_id')}`)
            .required(`${translate('this_field_cannot_be_left_blank')}`)
            .trim()
        : Yup.string(),
    vendorId:
      step === 1
        ? Yup.string()
            .matches(
              /^[a-zA-Z0-9_]*$/,
              `${translate('vendor_id_must_not_have_special_characters')}`,
            )
            .max(100, `${translate('enter_valid_vendor_id')}`)
            .required(`${translate('this_field_cannot_be_left_blank')}`)
            .trim()
        : Yup.string(),
    phone:
      step === 1
        ? Yup.string()
            .matches(
              /^[6-9][0-9]{9,12}$/,
              `${translate('enter_valid_contact_number')}`,
            )
            .required(`${translate('this_field_cannot_be_left_blank')}`)
            .trim()
        : Yup.string(),
    name:
      step === 2
        ? Yup.string()
            .matches(
              /^[a-zA-Z0-9-/&.\s]*$/,
              `${translate('account_holder_name_must_be_alphanumeric')}`,
            )
            .max(100, `${translate('enter_valid_account_holder_name')}`)
            .required(`${translate('this_field_cannot_be_left_blank')}`)
            .trim()
        : Yup.string(),
    vpa:
      step === 2
        ? Yup.string()
            .matches(/^[\w.-]+@[\w.-]+$/, `${translate('invalid_upi_id')}`)
            .trim()
        : Yup.string(),
    accountNumber:
      step === 2
        ? Yup.string()
            .matches(
              /^[a-zA-Z0-9]*$/,
              `${translate('account_number_must_be_alphanumeric')}`,
            )
            .min(9, `${translate('enter_valid_account_number')}`)
            .max(30, `${translate('enter_valid_account_number')}`)
            .when('vpa', {
              is: vpa => (vpa && vpa.length === 0) || !vpa,
              then: Yup.string().required(
                `${translate('this_field_cannot_be_left_blank')}`,
              ),
              otherwise: Yup.string().max(
                0,
                `${translate(
                  'bank_or_upi_only_one_can_be_passed_and_not_both',
                )}`,
              ),
            })
            .trim()
        : Yup.string(),
    ifsc:
      step === 2
        ? Yup.string()
            .length(11, `${translate('length_must_be_11')}`)
            .matches(
              /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/,
              `${translate('invalid_ifsc_code')}`,
            )
            .when('vpa', {
              is: vpa => (vpa && vpa.length === 0) || !vpa,
              then: Yup.string().required(
                `${translate('this_field_cannot_be_left_blank')}`,
              ),
              otherwise: Yup.string().max(
                0,
                `${translate(
                  'bank_or_upi_only_one_can_be_passed_and_not_both',
                )}`,
              ),
            })
            .trim()
        : Yup.string(),
    scheduleOption:
      step === 1
        ? Yup.string().required(
            `${translate('this_field_cannot_be_left_blank')}`,
          )
        : Yup.string(),
    accountType: step === 1 && Yup.string(),
    businessType:
      step === 1 && incrementalVendorOnboarding
        ? Yup.string().required(
            `${translate('this_field_cannot_be_left_blank')}`,
          )
        : Yup.string(),
  });

export default vendorDetailsFormvalidationSchema;
